import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import About from "./pages/About";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import Contact from "./pages/Contact";
import Event from "./pages/Event";
import Certificate from "./pages/Certificate";
import Gallery from "./pages/Gallery";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
// import CertificateList from "./pages/CertificateList";

function App() {
  return (
    <Router>
      {/* Routing */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/pratyarpan" element={<Event />} />
        {/* written for future use */}
        {/* <Route path="/certificates" element={<CertificateList />} /> */}
        <Route path="/certificates/:certificateId" element={<Certificate />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
